import { HttpError } from "@refinedev/core";
import type { AuthProviderName } from "@libertify/auth/core";
import {
  ATTEMPT_LIMIT_EXCEEDED_MESSAGE,
  INCORRECT_CURRENT_PASSWORD_MESSAGE,
} from "./constants";

// Only Cognito accounts (or an untagged null provider) have a password/MFA
// managed by us — social/SSO logins never do.
const isCognitoOrUnknownProvider = (authProvider: AuthProviderName | null) =>
  authProvider === null || authProvider === "cognito";

export const canChangePassword = isCognitoOrUnknownProvider;

export const canUseMfa = isCognitoOrUnknownProvider;

export const isIncorrectCurrentPasswordError = (error?: HttpError) =>
  error?.statusCode === 400 &&
  error.message === INCORRECT_CURRENT_PASSWORD_MESSAGE;

export const isAttemptLimitExceededError = (error?: HttpError) =>
  error?.statusCode === 400 && error.message === ATTEMPT_LIMIT_EXCEEDED_MESSAGE;

// These errors are shown inline on the form instead of the generic toast
// (see ChangePassword.tsx), so the toast must be suppressed for them.
export const shouldSuppressErrorToast = (error?: HttpError) =>
  isIncorrectCurrentPasswordError(error) || isAttemptLimitExceededError(error);
